import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPipesModule } from '../app-pipes/app-pipes.module';
import { CompanyDisplayDialogComponent } from './company-display-dialog/company-display-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, AppPipesModule],
  exports: [CompanyDisplayDialogComponent],
  declarations: [CompanyDisplayDialogComponent]
})
export class CompanyModule {}
